<template>
	<view class=""></view>
</template>

<script>
	import cookie from "@utils/store/cookie";
	import { login } from "@api/user";
	import dayjs from 'dayjs'
	const BACK_URL = "login_back_url";
	export default {
		data() {
			return {
				query:{}
			}
		},
		created() {
			const code = this.$route.query.code;
			if(!code) return;
			login({
				username: cookie.get('username'),
				captcha: cookie.get('captcha'),
				userCategory: 1,
				spread: cookie.get("spread"),
				code
			}).then(({ data }) => {
				console.log(data)
				this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
				this.$store.commit("SET_USER", data);
				const backUrl = cookie.get(BACK_URL) || "/";
				cookie.remove(BACK_URL);
				cookie.remove('username');
				cookie.remove('captcha');
				this.$router.replace({ path: '/' });
			})
			.catch((e) => {
				this.$router.replace({path: '/login',query: { errorTip: e.msg }});
			});
		},
	}
</script>